import React, { useState } from 'react';
import cx from 'classnames';

interface Props {
  'data-testid': string;
  onRemove: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  className?: string;
}

const RemoveButton = ({ onRemove, className, ...props }: Props) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const classNames = cx('text-primary-day-light underline sky-h5 md:sky-h7 md:font-light', className);
  const onClick = async (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setIsDisabled(true);
    onRemove(event);
    setIsDisabled(false);
  };

  return (
    <button {...props} className={classNames} onClick={event => onClick(event)} type="button" disabled={isDisabled}>
      Remove
    </button>
  );
};

export { RemoveButton };
